<template>
  <div class="overlay">
    <v-progress-circular
      :size="200"
      :width="7"
      color="primary"
      indeterminate
    />
  </div>
</template>

<script>
import axios from 'axios'
import repository from '@/store/repository'
import handleApiError from '@/plugins/handleApiError'

export default {
  data () {
    return {
      registResult: null
    }
  },
  computed: {
    // URLに格納されるidTokenやaccessTokenをjson化して格納する
    idTokens: function () {
      const res = {}
      const params = this.$route.hash.slice(1).split('&')

      for (const param of params) {
        const key = param.split('=')[0]
        const value = param.split('=')[1]
        res[key] = value
      }
      return res
    },

    // idTokenの中でbase64でエンコードされているユーザーデータをデコードし,json化する
    idTokenPayload: function () {
      return JSON.parse(atob(this.idTokens.id_token.split('.')[1]))
    }
  },

  mounted: async function () {
    const idtoken = this.idTokens.id_token
    const accesstoken = this.idTokens.access_token
    const username = this.idTokenPayload['cognito:username']
    let status = null

    this.$cognito.loginWithOtherProvider(username, idtoken, accesstoken)

    repository.setIdToken(idtoken)
    repository.setAccessToken(accesstoken)
    this.$store.commit('setIdToken', idtoken)
    this.$store.commit('setAccessToken', accesstoken)
    this.$store.commit('setUserName', username)

    await this.getCorrespondPjmUserId()
    await this.sendLog()

    // もし講座登録情報が repository にある場合、講座登録APIを叩く
    const id = repository.getRegistCourseId()

    if (id) {
      await this.registerCourse(id)
      if (this.registResult === 2) {
        status = false
      } else {
        status = true
      }
      repository.removeRegistCourseId()
    }
    if (status !== null) {
      this.$router.push({ name: 'Registered', params: { registStatus: status } })
    } else {
      this.$router.push({ name: 'CourseList' })
    }
  },

  methods: {
    async getCorrespondPjmUserId () {
      const reqUrl = process.env.VUE_APP_COGNITO_USER_ID_GET_API_URL
      const reqBody = {
        corpUserId: this.idTokenPayload['cognito:username'],
        authTime: this.idTokenPayload.auth_time,
        cognitoIdToken: this.idTokens.id_token
      }
      const header = {
        headers: {
          'x-api-key': process.env.VUE_APP_COGNITO_USER_ID_GET_API_KEY,
          'Content-Type': 'application/json',
          Authorization: repository.getAccessToken()
        }
      }

      const res = await axios.post(reqUrl, reqBody, header).catch(handleApiError)

      this.$store.commit('setUser', res.data[0])
      repository.setPjmUserId(res.data[0].pjmUserId)
    },

    async sendLog () {
      const reqUrl = process.env.VUE_APP_COGNITO_DB_USERLOG_API_URL
      const reqBody = {
        OperationType: 'PUT',
        Keys: {
          userId: this.idTokenPayload['cognito:username'],
          accessToken: this.idTokens.access_token,
          loginAt: this.idTokenPayload.auth_time
        }
      }
      const header = {
        headers: {
          'x-api-key': process.env.VUE_APP_COGNITO_DB_USERLOG_API_KEY,
          Authorization: repository.getAccessToken()
        }
      }

      await axios.post(reqUrl, reqBody, header).catch(handleApiError)
    },

    async registerCourse (courseId) {
      const reqUrl = process.env.VUE_APP_COURSE_REGISTRATION_API_URL

      const reqBody = {
        pjmUserId: String(repository.getPjmUserId()),
        cognitoIdToken: this.idTokens.id_token,
        cognitoUsername: this.idTokenPayload['cognito:username'],
        courseId: courseId
      }
      const header = {
        headers: {
          'x-api-key': process.env.VUE_APP_DB_API_KEY,
          'Content-Type': 'application/json',
          Authorization: repository.getAccessToken()
        }
      }

      // 講座登録API を叩く
      await axios.post(reqUrl, reqBody, header)
        .then(result => {
          this.registResult = result.data.registResult
        }).catch(handleApiError)
    }
  }
}
</script>

<style scoped>
/* 画面中央にローディングアニメーションを配置する */
.overlay{
  z-index:1;
  width:100%;
  height:100%;
  display: flex;
  justify-content: center;
}
</style>
